import React, { useMemo, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";
// import getCustomerCategories from "./CustomerCategories";
import Export from "../../../../components/Export";
import printChart from "../../../../PrintChart";
import Papa from "papaparse";
import DateRange from "../../../../components/DateRange";
import { Progress } from "nq-component";

import DefaultState from "../../../sales-and-transactions/components/DefaultState";
import getCustomerCategoriesCount from "../customer-count/CustomerCategoriesCount";

function SalesPerSegmentPage({
  transactions,
  onChangeDate,
  onChangeStore,
  dateField,
  store,
  storess,
  range,
  notFound,
}) {
  const [selectedStore, setSelectedStore] = useState("All");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const getUniqueStores = (transactions) => {
    const storeSet = new Set();
    transactions.forEach((transaction) => {
      const storeCode = transaction.store_code.replace("ANGELSPIZZA_", "");
      storeSet.add(storeCode);
    });
    return Array.from(storeSet);
  };

  const filteredTransactions = useMemo(() => {
    return transactions.filter((transaction) => {
      const tranDate = new Date(transaction.tran_date);
      const start = startDate ? new Date(startDate) : new Date(0); // Unix epoch start if empty
      const end = endDate ? new Date(endDate) : new Date();
      end.setHours(23, 59, 59, 999);
      return tranDate >= start && tranDate <= end;
    });
  }, [transactions, startDate, endDate]);

  const uniqueStores = useMemo(
    () => getUniqueStores(filteredTransactions),
    [filteredTransactions]
  );

  // const customerCategories = useMemo(
  //   () => getCustomerCategories(transactions),
  //   [transactions]
  // );
  const customerCategories = useMemo(
    () => getCustomerCategoriesCount(filteredTransactions, selectedStore),
    [filteredTransactions, selectedStore]
  );

  const loyalistCount = customerCategories.loyalists.length;
  const potentialLoyalistCount = customerCategories.potentialLoyalists.length;
  const promisingCount = customerCategories.promising.length;
  const hesitantCount = customerCategories.hesitant.length;
  const needAttentionCount = customerCategories.needAttention.length;
  const detractorsCount = customerCategories.detractors.length;

  const totalCount =
    loyalistCount +
    potentialLoyalistCount +
    promisingCount +
    hesitantCount +
    needAttentionCount +
    detractorsCount;

  const data = {
    labels: [
      "Loyalist",
      "Potential Loyalist",
      "PROMISING",
      "HESITANT",
      "NEED ATTENTION",
      "DETRACTORS",
    ],
    datasets: [
      {
        label: "Customer Count per Customer Type",
        data: [
          loyalistCount,
          potentialLoyalistCount,
          promisingCount,
          hesitantCount,
          needAttentionCount,
          // 0,
          // 0,
          // 0,
          // 0,
          // 0,
          detractorsCount,
        ],
        backgroundColor: [
          "#00589C",
          "#016FC4",
          "#1891C3",
          "#3AC0DA",
          "#3DC6C3",
          "#50E3C2",
        ],
        borderColor: [
          "#00589C",
          "#016FC4",
          "#1891C3",
          "#3AC0DA",
          "#3DC6C3",
          "#50E3C2",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false, // This allows the chart to fill the container
    aspectRatio: 2, // Adjust this value to change the chart size, default is 2 (which means width is twice the height)
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed !== null) {
              const percentage = ((context.parsed / totalCount) * 100).toFixed(
                2
              );
              label += `${percentage}%`;
            }
            return label;
          },
        },
      },
    },
  };

  const calculatePercentage = (count) =>
    ((count / totalCount) * 100).toFixed(2);

  const exportCsv = () => {
    const headers = [
      "brand", // Assuming 'brand' is equivalent to 'store' in your case
      "store",
      "start_date",
      "end_date",
      "category",
      "sales_percentage",
    ];
    // Prepare data for CSV
    const calculatePercentage = (count) =>
      ((count / totalCount) * 100).toFixed(2);
    const data = [
      {
        brand: "", // Replace with actual brand name if needed
        store: selectedStore,
        start_date: startDate || "Not set",
        end_date: endDate || "Not set",
        category: "Loyalist",
        sales_percentage: calculatePercentage(loyalistCount) + "%",
      },
      {
        brand: "", // Replace with actual brand name if needed
        store: selectedStore,
        start_date: startDate || "Not set",
        end_date: endDate || "Not set",
        category: "Potential Loyalist",
        sales_percentage: calculatePercentage(potentialLoyalistCount) + "%",
      },
      {
        brand: "", // Replace with actual brand name if needed
        store: selectedStore,
        start_date: startDate || "Not set",
        end_date: endDate || "Not set",
        category: "Promising",
        sales_percentage: calculatePercentage(promisingCount) + "%",
      },
      {
        brand: "", // Replace with actual brand name if needed
        store: selectedStore,
        start_date: startDate || "Not set",
        end_date: endDate || "Not set",
        category: "Hesitant",
        sales_percentage: calculatePercentage(hesitantCount) + "%",
      },

      {
        brand: "", // Replace with actual brand name if needed
        store: selectedStore,
        start_date: startDate || "Not set",
        end_date: endDate || "Not set",
        category: "Need Attention",
        sales_percentage: calculatePercentage(needAttentionCount) + "%",
      },
      {
        brand: "", // Replace with actual brand name if needed
        store: selectedStore,
        start_date: startDate || "Not set",
        end_date: endDate || "Not set",
        category: "Detatractors",
        sales_percentage: calculatePercentage(detractorsCount) + "%",
      },

      // ... [rest of your categories]
    ];

    // Convert to CSV
    const csv = Papa.unparse({
      fields: headers,
      data: data,
    });

    // Create a Blob from the CSV String
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "customer_categories.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const chartId = 41;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
        <h2 className="fw-bold text-capitalize">
          <span style={{ color: "#83c14a" }}>Sales</span>
          <span style={{ color: "black" }}> per</span>
          <span style={{ color: "#c5da55" }}> Segment</span>
        </h2>
        <Export exportCsv={exportCsv} exportPdf={() => printChart(chartId)} />
      </div>
      <div className="row"></div>
      {/* {transactions.length > 0 ? (
        <div id="41">
          <div className="card">
            <Doughnut data={data} options={options} />
          </div>
          <div className="print-only-content">
            <h2>Report Details</h2>
            <div className=" print-only-content">
              <div className="">
                <h3>Brand: Angels Pizza</h3>
                <h3>Store: {selectedStore}</h3>
                <h3>
                  Date: {startDate} - {endDate}
                </h3>
              </div>
            </div>
            <div className="" style={{ fontSize: "20px" }}>
              <table className="table text-center">
                <thead>
                  <tr className="d-flex">
                    <th>Type</th>
                    <th className="ms-5">Count</th>{" "}
                  </tr>
                </thead>
                Í
                <tbody>
                  {data.labels.map((label, index) => (
                    <tr className="d-flex" key={label}>
                      <td>{label}</td>
                      <td>
                        {calculatePercentage(data.datasets[0].data[index])}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : storess && range ? (
        <div className="text-center mt-5">
          <DefaultState />
        </div>
      ) : (
        <div className="text-center align-items-center mt-4">
          <img
            src="./choosefirst.png"
            style={{ height: "200px", width: "200px" }}
          />
          <h4 className="mt-4 fw-semibold text-muted text-center">
            👋 To get started, please select a{" "}
            <span className="text-success">date range</span> and{" "}
            <span className="text-success">store</span> above.
          </h4>
        </div>
      )} */}
      {transactions.length > 0 ? (
        <div id="41">
          <div className="card">
            <Doughnut data={data} options={options} />
          </div>
          <div className="print-only-content">
            <h2>Report Details</h2>
            <div className="print-only-content">
              <div>
                <h3>Brand: Angels Pizza</h3>
                <h3>Store: {selectedStore}</h3>
                <h3>
                  Date: {startDate} - {endDate}
                </h3>
              </div>
            </div>
            <div style={{ fontSize: "20px" }}>
              <table className="table text-center">
                <thead>
                  <tr className="d-flex">
                    <th>Type</th>
                    <th className="ms-5">Count</th>
                  </tr>
                </thead>
                <tbody>
                  {data.labels.map((label, index) => (
                    <tr className="d-flex" key={label}>
                      <td>{label}</td>
                      <td>
                        {calculatePercentage(data.datasets[0].data[index])}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : !storess || !range ? (
        <div className="text-center align-items-center mt-4">
          <img
            src="./choosefirst.png"
            style={{ height: "200px", width: "200px" }}
          />
          <h4 className="mt-4 fw-semibold text-muted text-center">
            👋 To get started, please select a{" "}
            <span className="text-success">date range</span> and{" "}
            <span className="text-success">store</span> above.
          </h4>
        </div>
      ) : notFound ? (
        <div className="text-center mt-5">
          <p className="text-muted fs-5">
            📭 Data not found for selected filter.
          </p>
        </div>
      ) : (
        <div className="text-center mt-5">
          <DefaultState />
        </div>
      )}
    </>
  );
}

export default SalesPerSegmentPage;
